<template>

	<page>
		<title-view>חבילות כרטיסים
			<v-btn slot="actions" color="primary" tile block @click="onEdit({lottery_id:lottery.id})">הוספת חבילה</v-btn>
		</title-view>
		<row>
			<c-col>
				<packages-table v-if="lottery.id" :key="lottery.id" :lottery="lottery" @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">עריכת כרטיס</span>
			<package-form @save="openModal=false"/>
		</popup-dialog>

	</page>


</template>

<script>
	import PackageForm from "src/views/packages/PackageForm";
	import PackagesTable from "src/views/packages/PackagesTable";
	import PackageModule from "src/store/modules/Package.module";
	export default {
		name: "packages-view",
		components: {PackagesTable, PackageForm},
		data() {
			return {
				openModal: false
			};
		},
		computed:{
			lottery(){
				return this.$store.state.LotteryModule.lottery;
			}
		},
		methods: {
			onEdit(mypackage) {
				this.$store.commit(PackageModule.types.GET, mypackage);
				this.openModal = true;
			}
		}

	};
</script>

<style scoped>

</style>
